export const UPDATE_PROJECT_ACTION = "UPDATE_PROJECT_ACTION";

export const updateProjectAction = (projectAction) => {
  return {
    type: UPDATE_PROJECT_ACTION, 
    projectAction
  }
}


// WEBPACK FOOTER //
// ./src/actions/projectAction.js